/* Search overlay: open/close + live suggestions from Shopify's predictive search */
(function () {
  var root = document.getElementById('LumosSearch');
  if (!root) return;

  var input = root.querySelector('.lumos-search__input');
  var defaultView = root.querySelector('[data-search-default]');
  var resultsView = root.querySelector('[data-search-results]');
  var queriesWrap = root.querySelector('[data-search-queries-wrap]');
  var queriesList = root.querySelector('[data-search-queries]');
  var productsWrap = root.querySelector('[data-search-products-wrap]');
  var productsList = root.querySelector('[data-search-products]');
  var emptyMsg = root.querySelector('[data-search-empty]');
  var allLink = root.querySelector('[data-search-all]');
  var footer = root.querySelector('[data-search-footer]');
  var searchUrl = root.querySelector('form').getAttribute('action');

  var lastFocus = null;
  var timer = null;
  var controller = null;

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function boldMatch(text, q) {
    var safe = escapeHtml(text);
    var idx = text.toLowerCase().indexOf(q.toLowerCase());
    if (idx === -1) return safe;
    return escapeHtml(text.slice(0, idx)) + '<strong>' + escapeHtml(text.slice(idx, idx + q.length)) + '</strong>' + escapeHtml(text.slice(idx + q.length));
  }

  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('lumos-search-open');
    // next frame so the transition runs
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      input.focus();
    });
  }

  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('lumos-search-open');
    setTimeout(function () { root.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showDefault() {
    footer.hidden = true;
    resultsView.hidden = true;
    defaultView.hidden = false;
  }

  function render(q, data) {
    var res = (data && data.resources && data.resources.results) || {};
    var queries = res.queries || [];
    var products = res.products || [];

    queriesList.innerHTML = queries.map(function (item) {
      return '<li><a href="' + searchUrl + '?q=' + encodeURIComponent(item.text) + '&type=product">' + boldMatch(item.text, q) + '</a></li>';
    }).join('');
    queriesWrap.hidden = !queries.length;

    productsList.innerHTML = products.map(function (item) {
      var img = item.image ? '<img src="' + escapeHtml(item.image) + '" width="48" height="48" alt="" loading="lazy">' : '';
      return '<li><a class="lumos-search__item" href="' + escapeHtml(item.url) + '">' + img + '<span>' + escapeHtml(item.title) + '</span></a></li>';
    }).join('');
    productsWrap.hidden = !products.length;

    emptyMsg.hidden = !!(queries.length || products.length);
    footer.hidden = !products.length;
    allLink.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';

    defaultView.hidden = true;
    resultsView.hidden = false;
  }

  function fetchSuggestions(q) {
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;

    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=query,product&resources[limit]=5&resources[limit_scope]=each';

    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (input.value.trim() === q) render(q, data);
      })
      .catch(function () { /* aborted or offline: keep what is shown */ });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (!q) { showDefault(); return; }
    timer = setTimeout(function () { fetchSuggestions(q); }, 200);
  });

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-open-search]');
    if (openBtn) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });
})();
